import React from 'react';
import { Link } from 'react-router-dom';
import Card from './Card';
import Badge from './Badge';
import EmptyState from './EmptyState';
import Skeleton from './Skeleton';
import TextLink from './TextLink';

/** Compact dashboard surface with shared loading, empty and footer placement. */
export default function WidgetCard({ title, headerBadge, viewAll, viewAllLabel = 'View all', footer,
  isLoading, isEmpty, emptyMessage, emptyIcon: EmptyIcon, children, rows = false, onClick }) {
  return <Card aria-label={title} onClick={onClick} interactive={!!onClick} className={onClick ? 'cursor-pointer' : undefined}>
    <Card.Header title={title} actions={<>
      {headerBadge && <Badge>{headerBadge}</Badge>}
      {footer && viewAll && <TextLink as={Link} to={viewAll}>{viewAllLabel}</TextLink>}
    </>} />
    {isLoading ? <Card.Section role="status" aria-label={`Loading ${title}`}><Skeleton height={100} /></Card.Section>
      : isEmpty ? <Card.Section><EmptyState compact title={emptyMessage} icon={EmptyIcon && <EmptyIcon />} /></Card.Section>
        : rows ? children : <Card.Section>{children}</Card.Section>}
    {(footer || viewAll) && <Card.Footer>
      {footer || <TextLink as={Link} to={viewAll}>{viewAllLabel}</TextLink>}
    </Card.Footer>}
  </Card>;
}
